export const CalendarAddIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={className}
    >
      <path
        fill="currentColor"
        d="M17.398 19.221H15.25a.82.82 0 0 1-.606-.247.83.83 0 0 1-.246-.612.82.82 0 0 1 .246-.608.83.83 0 0 1 .606-.242h2.148v-2.149a.82.82 0 0 1 .247-.605.83.83 0 0 1 .61-.246q.362 0 .604.245a.83.83 0 0 1 .243.607v2.148h2.148q.36 0 .606.247a.83.83 0 0 1 .246.612.82.82 0 0 1-.246.608.83.83 0 0 1-.606.242h-2.148v2.142a.83.83 0 0 1-.247.613.83.83 0 0 1-.61.245.836.836 0 0 1-.847-.858zm-12.844.928q-.69 0-1.197-.506a1.64 1.64 0 0 1-.506-1.197V5.054q0-.693.506-1.201a1.63 1.63 0 0 1 1.197-.509h1.571v-.646q0-.358.25-.606a.83.83 0 0 1 .605-.248.85.85 0 0 1 .62.248.82.82 0 0 1 .252.606v.646h6.296v-.646q0-.358.25-.606a.83.83 0 0 1 .605-.248.85.85 0 0 1 .62.248.82.82 0 0 1 .252.606v.646h1.571q.693 0 1.201.509.51.51.509 1.2v6.57a.82.82 0 0 1-.25.613.84.84 0 0 1-.613.245.837.837 0 0 1-.847-.858V9.75H4.554v8.696h6.975q.36 0 .609.247a.82.82 0 0 1 .249.61.8.8 0 0 1-.25.604.84.84 0 0 1-.608.242zm0-11.899h12.892V5.054H4.554z"
      />
    </svg>
  );
};
